import type { ReactNode } from "react";

export function TestaPagina({ titolo, sottotitolo }: { titolo: string; sottotitolo?: ReactNode }) {
  return (
    <header className="testa-pagina">
      <h1>{titolo}</h1>
      <span className="filetto-pagina" aria-hidden="true" />
      {sottotitolo && <p className="sottotitolo-pagina">{sottotitolo}</p>}
    </header>
  );
}
